import PropTypes from 'prop-types'

const BasicListItem = ({itemValue, listItem}) => (
  <>
    <strong>{listItem}</strong>: {itemValue}
  </>
)

BasicListItem.displayName = 'BasicListItem'
BasicListItem.propTypes = {
  itemValue: PropTypes.string.isRequired,
  listItem: PropTypes.string.isRequired
}

export default BasicListItem
